import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { useLayoutStore } from "@/store";
import { LogoSmall } from "@/assets";
import { useApp } from "@/app/app-context";
import { cn } from "@/lib/utils";
import { ChevronDown } from "lucide-react";
import {
  GARAGE_REGISTER_ALL_ENTITY,
  isGarageRegisterAllEntities,
} from "@/lib/garage-register-entity-scope";

export function EntitySwitcher() {
  const { entities, selectedEntity, handleEntityChange, currentApp } = useApp();
  const { sidebarState } = useLayoutStore();
  const isCollapsed = sidebarState === "collapsed";

  const showAllGaragesOption =
    currentApp?.key === "garageregister" &&
    entities.some((e) => e.entity_type === "garageregister");

  if (entities.length === 0) {
    return (
      <div className="flex items-center justify-center w-full h-fit overflow-hidden border rounded-md p-2 gap-2 bg-gray-50">
        <LogoSmall />
        {!isCollapsed && <h2 className="text-base text-gray-500">No Access</h2>}
      </div>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className="flex items-center justify-center 
      bg-[#F8FAFC] w-full focus:ring-0 focus:outline-none"
      >
        <div
          className="group/entity-switcher w-full border rounded-md overflow-hidden 
        transition-colors hover:bg-slate-100"
        >
          <div className="flex justify-center items-center p-2 gap-2">
            <LogoSmall className="flex-shrink-0" />
            {!isCollapsed && (
              <h2 className="text-sm font-semibold">
                {isGarageRegisterAllEntities(selectedEntity)
                  ? GARAGE_REGISTER_ALL_ENTITY.entity_name
                  : selectedEntity?.entity_name || "Select Entity"}
              </h2>
            )}
          </div>

          <div
            className="bg-[#E2E8F0] border-t border-gray-300 py-0 flex 
            justify-center transition-all duration-700 ease-in-out
            opacity-0 max-h-0 overflow-hidden group-hover/entity-switcher:opacity-100 
            group-hover/entity-switcher:max-h-8"
          >
            <ChevronDown
              className="text-gray-500"
              style={{ width: ".8rem", height: ".8rem" }}
            />
          </div>
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-[--radix-popper-anchor-width] ml-2 max-h-[min(60vh,24rem)] overflow-y-auto overflow-x-hidden">
        {showAllGaragesOption && (
          <DropdownMenuItem
            key="garageregister-all"
            onClick={() => handleEntityChange(GARAGE_REGISTER_ALL_ENTITY)}
            className={cn(
              isGarageRegisterAllEntities(selectedEntity) ? "bg-slate-100" : "",
              "cursor-pointer"
            )}
          >
            <div className="flex items-center gap-1">
              <LogoSmall
                className="flex-shrink-0"
                style={{ width: "20px", height: "20px" }}
              />
              <div className="flex flex-col">
                <span className="font-medium">
                  {GARAGE_REGISTER_ALL_ENTITY.entity_name}
                </span>
              </div>
            </div>
          </DropdownMenuItem>
        )}
        {entities.map((entity) => (
          <DropdownMenuItem
            key={`${entity.entity_type}-${entity.entity_id}`}
            onClick={() => handleEntityChange(entity)}
            className={cn(
              selectedEntity?.entity_id === entity.entity_id &&
                selectedEntity?.entity_type === entity.entity_type
                ? "bg-slate-100"
                : "",
              "cursor-pointer"
            )}
          >
            <div className="flex items-center gap-1">
              <LogoSmall
                className="flex-shrink-0"
                style={{ width: "20px", height: "20px" }}
              />
              <div className="flex flex-col">
                <span className="font-medium">{entity.entity_name}</span>
              </div>
            </div>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
